
import React, { useContext } from 'react';
import { AppContext } from '../contexts/AppContext';

const HeaderLanding: React.FC = () => {
    const { setUnauthenticatedView } = useContext(AppContext);

    return (
        <header className="bg-white/80 backdrop-blur-md sticky top-0 z-50 shadow-sm">
            <div className="container mx-auto px-6 py-4 flex justify-between items-center">
                <a href="/" className="flex items-center">
                    <img src="/logo.png" alt="Tu Club" className="h-10" />
                </a>
                <nav className="hidden md:flex space-x-8 items-center">
                    <a href="#features" className="text-gray-600 hover:text-blue-600 transition-colors">Características</a>
                    <a href="#pricing" className="text-gray-600 hover:text-blue-600 transition-colors">Planes</a>
                    <a href="#contact" className="text-gray-600 hover:text-blue-600 transition-colors">Contacto</a>
                </nav>
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        setUnauthenticatedView('login');
                    }}
                    className="bg-blue-600 text-white px-5 py-2 rounded-full font-semibold hover:bg-blue-700 transition-transform transform hover:scale-105"
                >
                    Iniciar Sesión
                </a>
            </div>
        </header>
    );
};

export default HeaderLanding;
